
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Injectable } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import localeDe from "@angular/common/locales/de";
import localeEn from "@angular/common/locales/en";
import localeRu from "@angular/common/locales/ru";
import localeEnExtra from "@angular/common/locales/extra/en";
import localeDeExtra from "@angular/common/locales/extra/de";
import localeRuExtra from "@angular/common/locales/extra/ru";

@Injectable({
  providedIn: "root"
})
export class LocaleService {

    constructor() {

    }
    private _locale: string;

    set locale(value: string) {
        this._locale = value;
    }
    get locale(): string {
        return this._locale || "en-US";
    }

    registerLocale(culture: string) {
        if (!culture) {
            return;
        }
        this.locale = culture;

        // Register locale data since only the en-US locale data comes with Angular
        switch (culture) {
            case "en": {
                registerLocaleData(localeEn, culture, localeEnExtra);
                break;
            }
            case "de": {
                console.log("called::::::::::::::::", localeDe);
                registerLocaleData(localeDe, culture, localeDeExtra);
                break;
            }
            case "ru": {
                console.log("called::::::::::::::::", localeRu);
                registerLocaleData(localeRu, culture, localeRuExtra);
                break;
            }
        }
    }
}
